<div class="content">
  <div class="tabs-container">
    <app-tabs
      class="tabs"
      [items]="tabs"
      [(selectedTabIndex)]="tabIndex"
      [fillModeEnabled]="false"
      [appBlockModalDrag]="!(isMobileModeObservable | async)"
    ></app-tabs>
  </div>

  <div class="results-container">
    <ng-template
      [ngTemplateOutlet]="resultsTpl"
      [ngTemplateOutletContext]="{
        tabIndexKey: 0,
        columns: fixeColumns,
        results: fixeNetworkItems,
        icon: fixeNetworkIcon,
        footerText: fixeNetworkFooterText,
      }"
    ></ng-template>

    <ng-template
      [ngTemplateOutlet]="resultsTpl"
      [ngTemplateOutletContext]="{
        tabIndexKey: 1,
        columns: mobileColumns,
        results: mobileNetworkItems,
        icon: mobileNetworkIcon,
        footerText: mobileNetworkFooterText,
      }"
    ></ng-template>

    <ng-template
      [ngTemplateOutlet]="resultsTpl"
      [ngTemplateOutletContext]="{
        tabIndexKey: 2,
        columns: satelliteColumns,
        results: satelliteNetworkItems,
        icon: satelliteNetworkIcon,
        footerText: satelliteNetworkFooterText,
      }"
    ></ng-template>
  </div>
</div>

<ng-template
  #resultsTpl
  let-tabIndexKey="tabIndexKey"
  let-results="results"
  let-columns="columns"
  let-icon="icon"
  let-footerText="footerText"
>
  <ng-container *appDeferRendering="tabIndexKey === tabIndex">
    <app-results-table-view
      class="table-view"
      [columns]="columns"
      [results]="results"
      [hidden]="tabIndexKey !== tabIndex"
    ></app-results-table-view>

    <div class="tab-footer" [hidden]="tabIndexKey !== tabIndex">
      <div class="icon-container">
        <app-iconic class="icon" [icon]="icon"></app-iconic>
      </div>

      <div class="text" *ngIf="!!footerText">
        <span [innerHTML]="footerText"> </span>
      </div>
    </div>
  </ng-container>
</ng-template>
